const SubAbasKits = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/produtosdaf/kits/${id}/dadosgerais`,
  },
  // {
  //   label: 'Vínculos',
  //   rota: `/daf/produtosdaf/kits/ficha/${id}/vinculos`,
  // },
];

export default SubAbasKits;
